module.exports = __webpack_public_path__ + "img/persona.97ed05fd.gif";